type Props = {
  requiredCondition: boolean,
  fallbackComponent?: JSX.Element,
  children?: JSX.Element
}

const RequiresCondition = ({ requiredCondition, fallbackComponent = null, children }: Props) => {
  if (!requiredCondition) {
    return fallbackComponent
  }

  return children
}

export default RequiresCondition
